import { createContext } from "react";

const archivosContext = createContext();

export default archivosContext;
